module.exports = {
    default: 0,
    brand: 1,
    collection: 2,
}